import React from 'react'

import quoteIconSrc from './quote-icon.svg'

import './style.css'

const Testimonial = ({
  role,
  company,
  quote,
  faceIconSrc,
  nameIconSrc,
}) => (
  <div className="setup-testimonial">
    <div className="setup-testimonial-box">
      <p className="setup-testimonial-quote" >
        <img src={quoteIconSrc} className="setup-testimonial-quote-icon" alt=""/>
        <div>
          {quote}
        </div>
      </p>
      <img src={faceIconSrc} className="setup-testimonial-face-icon" alt="Leo"/>
    </div>
    <img className="setup-testimonial-name" src={nameIconSrc} alt=""/>
    <p className="setup-testimonial-title">{role} | {company}</p>
  </div>
)

export default Testimonial



// WEBPACK FOOTER //
// ./src/layouts/Testimonial/index.js